document.addEventListener("DOMContentLoaded", () => {
  const trackedOutboundLinks = document.querySelectorAll(
    "[data-posthog-event]",
  );
  trackedOutboundLinks.forEach((link) => {
    link.addEventListener("click", () => {
      if (typeof window.posthog === "undefined") {
        return;
      }

      const eventName = link.dataset.posthogEvent;
      if (!eventName) {
        return;
      }

      window.posthog.capture(eventName, {
        page_path: window.location.pathname,
        page_title: document.title,
        link_href: link.href,
        link_text: (link.textContent || "").trim(),
      });
    });
  });

  // --- Scroll-Reveal Animation ---
  const scrollRevealElements = document.querySelectorAll(".scroll-reveal");
  const observerOptions = {
    root: null,
    rootMargin: "0px",
    threshold: 0.1,
  };
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add("active");
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);
  scrollRevealElements.forEach((el) => observer.observe(el));

  // --- Contact Form Submission Logic ---
  const contactForm = document.getElementById("contact-form");
  if (contactForm) {
    const statusEl = contactForm.querySelector(".form-status");
    const submitButton = contactForm.querySelector('button[type="submit"]');
    const apiEndpoint = contactForm.dataset.apiEndpoint;

    contactForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      submitButton.disabled = true;
      statusEl.textContent = "Sending...";
      statusEl.className = "form-status sending";

      const formData = Object.fromEntries(new FormData(e.target));
      const payload = {
        email: formData.email,
        subscribe_newsletter: !!formData.subscribe_newsletter,
        source: "Main Contact Form",
      };

      let mainFormSuccess = false;
      let brevoSuccess = true; // Assume true if not attempting or successful

      try {
        const response = await fetch(apiEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.error || "An unknown error occurred.");
        }
        mainFormSuccess = true;
      } catch (error) {
        statusEl.textContent = `Error: ${error.message}`;
        statusEl.className = "form-status error";
      }

      if (mainFormSuccess && payload.subscribe_newsletter) {
        try {
          const brevoEndpoint =
            "https://7ef60359.sibforms.com/serve/MUIFAPRl-eXkIKpwiXSHTFN8IsyqQhPIaJMeVY0OXpcZVs4yM9vFyPt8d6vfHH0Oc7WSUGVIC1v-oS499QgH0KdlyaAFXQYx3To2uPP-kgU1uuNdAezu2mdM1ZnYrxh-cIQAobsyWj3IUGI_FXwNEGGW5EqWWIcP3tkzyMzH0b0Zwgg0rMfwID2YB2nPUBcMVujHU2GQCenVcoj3";
          const brevoBody = new URLSearchParams();
          brevoBody.append("EMAIL", payload.email);
          brevoBody.append("email_address_check", "");
          brevoBody.append("locale", "en");

          await fetch(brevoEndpoint, {
            method: "POST",
            body: brevoBody,
            mode: "no-cors",
          });
          brevoSuccess = true;
        } catch (err) {
          console.error(
            "Brevo subscription background submission failed:",
            err,
          );
          brevoSuccess = false;
        }
      }

      if (mainFormSuccess) {
        if (brevoSuccess) {
          statusEl.textContent = "Thank you! We will be in touch shortly.";
          statusEl.className = "form-status success";
        } else {
          statusEl.textContent =
            "Thank you! We will be in touch shortly. (Newsletter subscription failed.)";
          statusEl.className = "form-status warning"; // Use a warning class for partial success
        }
        contactForm.reset();
      }
      submitButton.disabled = false;
    });
  }
});

// Language toggle (EN/FR/DE)
// English is the page HTML itself; these hold FR/DE for keys shared across
// pages. Page-specific keys live in js/i18n-<page>.js (window.FORSYT_PAGE_I18N).
const i18n = {
  fr: {
    "nav.products": "Produits ▾",
    "nav.solutions": "Solutions ▾",
    "nav.resources": "Ressources ▾",
    "nav.about": "À propos ▾",
    "nav.about_forsyt_title": "À propos de Forsyt Energy",
    "nav.about_forsyt_desc": "Notre mission, nos dirigeants & notre vision",
    "nav.work_with_us_title": "Rejoignez-nous",
    "nav.work_with_us_desc": "Découvrez nos offres et rejoignez l'équipe",
    "nav.contact_title": "Contact",
    "nav.contact_desc": "Prenez contact avec nos experts",
    "nav.demo": "Réserver un appel",
    "nav.insights": "Insights",
    "nav.val_title": "ValuationPro",
    "nav.val_desc": "Valorisation & projections financières long terme",
    "nav.bench_title": "BenchmarkPro",
    "nav.bench_desc": "Audits de performance & baselines spécifiques",
    "nav.toll_title": "Tolling & Optimisation",
    "nav.toll_desc": "Structures contractuelles & arbitrage de marché",
    "nav.coloc_title": "Colocalisation PV + BESS",
    "nav.coloc_desc": "Dimensionnement & co-optimisation d'actifs hybrides",
    "nav.audit_title": "Audits de Performance",
    "nav.audit_desc": "Vérification indépendante des taux de capture",
    "nav.insights_title": "Insights",
    "nav.insights_desc": "Analyses d'experts & recherches sur l'énergie",
    "nav.bess_ref_title": "Rapports BESS Reference",
    "nav.bess_ref_desc": "Indices trimestriels des revenus des batteries",
    "nav.ai_api_title": "Intégrations IA & API",
    "nav.ai_api_desc":
      "Connectez vos assistants IA (ChatGPT, Claude) à l'API Forsyt",
    "hero.main_title":
      "Identifiez les projets batterie qui méritent d'être construits.",
    "hero.main_subtitle":
      "ValuationPro teste chaque actif face aux prix prévisionnels, aux contraintes réseau, à l'accès aux marchés, aux configurations de co-implantation PV et aux stratégies d'exploitation. Notre plateforme révèle ce que le projet rapportera, où se situe le downside, et quels choix font ou défont le business case.",
    "hero.what_we_do": "CE QUE NOUS FAISONS",
    "audience.title": "Qui utilise ValuationPro ?",
    "audience.intro": "Forsyt travaille avec :",
    "audience.l1":
      "<strong>Développeurs BESS et équipes projet</strong> qui construisent le business case d'un nouvel actif et ont besoin de projections de revenus ancrées dans la façon dont la batterie va réellement trader.",
    "audience.l2":
      "<strong>Investisseurs et prêteurs</strong> qui réalisent une due diligence sur des projets BESS ou hybrides et ont besoin de TRI et VAN avec des hypothèses spécifiques à l'actif, documentées et interrogeables.",
    "audience.l3":
      "<strong>Propriétaires solaires évaluant l'hybridation</strong> qui doivent dimensionner la batterie, quantifier la valeur ajoutée et identifier quelle configuration offre le meilleur rendement à mesure que les taux de capture se compriment.",
    "audience.market_focus":
      "Nous couvrons les batteries de grande capacité sur les marchés européens, sur le day-ahead, l'infrajournalier et les services système.",
    "about.p3":
      "Nous couvrons le <strong>BESS standalone</strong>, l'hybridation <strong>PV et éolien</strong>, et les applications <strong>C&I</strong>, y compris l'optimisation de consommation des data centers.",
    "audience.footnote":
      "Modélisation de revenus spécifique à l'actif, construite sur un moteur de dispatch de qualité trading.",
    "audience.cta": "Voir ValuationPro en action",
    "benchmark.title": "ValuationPro",
    "benchmark.sub":
      "Valorisation BESS spécifique à l'actif, construite sur un modèle de trader.",
    "bench.key_metrics": "Métriques BESS clés",
    "bench.card1.title": "Configurez votre actif précisément",
    "bench.card1.desc":
      "ValuationPro reprend les vrais paramètres de votre batterie : puissance, dégradation, limites SoC, contraintes réseau et renouvelables co-localisées.",
    "bench.card1.l1":
      "Puissance, capacité, rendement et limites SoC adaptés à l'équipement et à l'exploitation.",
    "bench.card1.l2":
      "Courbes de dégradation, OPEX et tarifs réseau reflétés dans les cashflows.",
    "bench.card1.l3":
      "Support hybride pour prévisions ENR, curtailment, subventions et co-optimisation.",
    "bench.card2.title": "Financements du business case",
    "bench.card2.desc":
      "Transformez les simulations de dispatch en prévisions de revenus, TRI, VAN et payback prêts à décider.",
    "bench.card2.l1":
      "Cashflows pro-forma sur la durée de vie avec métriques d'investissement.",
    "bench.card2.l3":
      "Stack de revenus par produit : day-ahead, intraday, aFRR et FCR.",
    "bench.card2.l4":
      "Comparez taille, configuration et hypothèses pour la revue d'investissement.",
    "bench.card3.title": "Leviers de revenus et risques",
    "bench.card3.desc":
      "Voyez d'où viennent les revenus, ce qui les contraint et quelles hypothèses pilotent le résultat.",
    "bench.card3.l1":
      "Composition mensuelle, hebdomadaire et quotidienne des revenus par produit.",
    "bench.card3.l2":
      "Throughput, cyclage et dégradation liés à la valeur long terme.",
    "bench.card3.l3":
      "Diagnostics de contraintes et d'exploitation pour les sensibilités clés.",
    "bench.card3.l4":
      "Export de séries temporelles pour l'analyse de sensibilité, l'audit et la revue des prêteurs.",
    "about.hero_subtitle":
      "Nous aidons les acteurs du marché à comprendre ce qu'une batterie aurait raisonnablement pu gagner, comment sa performance réelle se compare, et d'où vient l'écart.",
    "about.title": "Présentation de l'entreprise",
    "about.p1":
      "<strong>Forsyt Energy</strong> est une société d'analyse indépendante spécialisée dans la performance des systèmes de stockage par batterie (BESS). Nous aidons les acteurs du marché à comprendre ce qu'une batterie aurait raisonnablement pu gagner, comment sa performance réelle se compare, et d'où vient l'écart. Nous fournissons des analyses précises et fiables pour la prise de décision.",
    "about.what_title": "Ce que fait Forsyt Energy",
    "about.what_p1":
      "Forsyt Energy construit des références commerciales spécifiques à chaque actif pour mesurer la performance du stockage par batterie. Notre approche combine rejeu de marché, expertise des marchés de l'électricité et modélisation physique, afin que l'analyse des revenus reflète les contraintes réelles et l'accès aux marchés de l'actif étudié.",
    "about.what_p2": "Notre gamme de produits comprend :",
    "about.bench_title": "BenchmarkPro",
    "about.bench_desc":
      "un benchmark de revenus de marché spécifique à l'actif pour les BESS, qui analyse la performance financière et la qualité d'exécution de l'optimiseur.",
    "about.val_title": "ValuationPro",
    "about.val_desc":
      "un moteur d'estimation des revenus BESS (valorisation) sur toute la durée de vie de l'actif, d'une grande précision et hautement paramétrable, avec l'hybridation ENR intégrée nativement.",
    "about.fore_title": "ForecastPro",
    "about.fore_desc":
      "notre produit de prévision des prix de l'électricité, construit sur notre propre moteur de modélisation fondamentale.",
    "about.what_p3":
      "Nous accompagnons les énergéticiens et les investisseurs grâce à une expertise approfondie des marchés de l'électricité, de la régulation et de l'économie des actifs. Nos travaux servent à la revue de performance, à la due diligence, au suivi, au reporting aux parties prenantes et aux discussions commerciales, lorsqu'un indice de marché générique ne suffit pas à dire ce qui était réellement accessible à une batterie donnée.",
    "about.who_title": "Qui sert Forsyt Energy",
    "about.who_l1": "Propriétaires d'actifs batterie, IPP et énergéticiens.",
    "about.who_l2":
      "Optimiseurs et agrégateurs qui ont besoin d'une référence de performance crédible.",
    "about.who_l3":
      "Banques, prêteurs et investisseurs qui évaluent la qualité des revenus d'une batterie.",
    "about.who_l4":
      "Équipes chargées du suivi, du reporting et de la revue de niveau audit des BESS.",
    "about.where_title": "Où opère Forsyt Energy",
    "about.where_p1":
      "Forsyt Energy a été fondée par Julio Quintela Casal et Lucas Durupt et est basée à Paris. Nous travaillons sur les enjeux du stockage par batterie de grande capacité sur les marchés européens de l'électricité. Nos publications actuelles portent sur le dispatch des batteries en Europe, notamment les opportunités de revenus sur le day-ahead, l'infrajournalier, la FCR et l'aFRR.",
    "about.services_title": "Notre offre de services",
    "about.services_p1":
      "Forsyt Energy fournit des analyses indépendantes basées sur les données tout au long du cycle de vie des actifs de stockage par batterie. En associant la simulation de dispatch tenant compte de la physique à la modélisation fondamentale du marché de l'électricité, nous accompagnons nos clients à travers trois services clés :",
    "about.services_l1":
      "<strong>Audits de performance & baselines (via BenchmarkPro) :</strong> Nous créons un jumeau numérique de votre batterie pour rejouer les conditions de marché historiques. Cela fournit une référence neutre de niveau audit pour évaluer la qualité du dispatch, vérifier les captures des agrégateurs et résoudre les litiges commerciaux.",
    "about.services_l2":
      "<strong>Valorisation de projets & dimensionnement techno-économique (via ValuationPro) :</strong> Nous simulons les revenus de la batterie sur toute sa durée de vie en intégrant les courbes de dégradation et les contraintes de raccordement. Ce service soutient la due diligence, l'optimisation du mix de revenus et le dimensionnement d'actifs hybrides (solaire PV + éolien + BESS).",
    "about.services_l3":
      "<strong>Scénarios fondamentaux de prix (via ForecastPro) :</strong> Nous livrons des prévisions à long terme de prix et de volatilité de l'électricité basées sur notre propre modèle fondamental de dispatch européen. Ces scénarios bancables soutiennent le financement de projets, la structuration des revenus et les stratégies de couverture.",
    "about.work_title": "Comment travailler avec nous",
    "about.work_p1":
      "Pour étudier un actif précis, discuter d'un pilote ou savoir si BenchmarkPro répond à votre besoin, commencez par la <a href=\"index.html\">page d'accueil</a>, consultez nos <a href=\"insights.html\">Insights</a>, ou écrivez-nous à <a href=\"mailto:contact@forsytenergy.com\">contact@forsytenergy.com</a>.",
    "contact.title": "Parlez-nous de votre projet",
    "contact.sub": "Entrez votre email ci-dessous et nous vous recontacterons.",
    "contact.placeholder": "votre.email@entreprise.com",
    "contact.newsletter":
      "Abonnez-vous à notre newsletter bimensuelle pour des informations sur le marché.",
    "contact.consent":
      "J'accepte les <a href='terms.html' target='_blank' rel='noopener noreferrer'>conditions d'utilisation</a> et la <a href='privacy.html' target='_blank' rel='noopener noreferrer'>politique de confidentialité</a>.",
    "contact.button": "Contactez-nous",
    "contact.direct": "Ou écrivez-nous directement à ",
    "cookie.text":
      'Nous utilisons des cookies essentiels pour les fonctionnalités de base du site. Avec votre consentement, nous utilisons également des cookies pour des analyses anonymes afin de comprendre comment vous utilisez le site, ce qui peut inclure l\'enregistrement de session. Cela nous aide à améliorer notre site Web. En savoir plus dans notre <a href="/privacy.html">Politique de confidentialité</a>.',
    "cookie.reject": "Tout refuser",
    "cookie.accept": "Tout accepter",
    "pilot.title": "Étude de dimensionnement ValuationPro",
    "pilot.sub":
      "Un <strong>business case BESS complet</strong> pour votre actif, en deux semaines.",
    "pilot.price":
      '<s class="price-old">7 000 €</s><span class="price-current">3 000 € HT</span>',
    "pilot.get.title": "Ce que vous obtenez",
    "pilot.get.l1":
      "ValuationPro configuré pour votre actif sur <strong>jusqu'à quatre scénarios BESS</strong>.",
    "pilot.get.l2":
      "Accès à la plateforme tout au long de la mission, avec visualisation complète des résultats.",
    "pilot.get.l3":
      "Un rapport synthétique et un <strong>export de données prêt pour vos modèles</strong> avec tous les résultats de scénarios, incluant la décomposition annuelle des revenus par produit de marché.",
    "pilot.inline": "Démarrer votre étude de dimensionnement",
    "pilot.timeline.title": "Calendrier",
    "pilot.timeline.t1":
      "<strong>Aujourd'hui :</strong> Appel de lancement de 30 min. NDA et lettre de mission prêts à signer. L'étude démarre sous 48 heures.",
    "pilot.timeline.t2":
      "<strong>Semaine 1 :</strong> Premiers résultats de scénario disponibles dans ValuationPro. Point d'étape avec Forsyt.",
    "pilot.timeline.t3":
      "<strong>Semaine 2 :</strong> Remise du rapport et d'un export de données prêt pour vos modèles avec l'ensemble des résultats et la décomposition des revenus.",
    "pilot.timeline.t4": "",
    "pilot.timeline.t5": "",
    "pilot.cta.book": "Réserver un appel avec notre équipe",
    "audit.title": "Audit de Benchmark de Performance",
    "audit.sub":
      "Quand les questions sont importantes, un tableau de bord ne suffit pas. Obtenez une vue structurée de ce que l'actif aurait pu gagner, comment la performance réelle se compare, et quels points méritent attention.",
    "audit.price": "4 900 € HT",
    "audit.get.title": "Ce que vous recevez",
    "audit.get.l1":
      "Une revue structurée de la performance récente de l'actif via un replay de trading spécifique.",
    "audit.get.l2":
      "Décomposition claire des revenus par produit, incluant le spot, l'infrajournalier et les services système.",
    "audit.get.l3":
      "Analyses approfondies des décisions et des conditions qui ont le plus façonné les résultats.",
    "audit.get.l4":
      "Recommandations pratiques pour la surveillance, le reporting et les prochaines priorités.",
    "audit.cta.book": "Discuter d'un audit",
    "audit.note": "",
    "audit.sample": "Livrables (cliquez pour plein écran)",
    "faq.title": "Foire aux questions",
    "faq.q1": "Comment ValuationPro produit-il des projections de revenus ?",
    "faq.a1":
      "ValuationPro fonctionne sur <strong>ASTRA</strong>, le modèle de dispatch BESS propriétaire de Forsyt. Il optimise votre actif sur tous les marchés pertinents (day-ahead, intraday, aFRR, FCR) à une granularité de 15 minutes, configuré selon vos paramètres techniques spécifiques. Les projections de flux de trésorerie sont construites à partir des résultats du dispatch.",
    "faq.q2":
      "Quelles informations me faut-il pour lancer une étude de dimensionnement ?",
    "faq.a2":
      "Les paramètres de base de l'actif : puissance nominale, capacité, localisation et pour les projets hybrides la configuration ENR. Lorsque les données sont incomplètes, nous nous appuyons sur la base de connaissances BESS de Forsyt et signalons quelles hypothèses sont les plus sensibles au résultat.",
    "faq.q4":
      "Les résultats peuvent-ils être utilisés dans un financement formel ou une due diligence ?",
    "faq.a4":
      "Oui. La méthodologie est spécifique à l'actif et les hypothèses sont <strong>entièrement documentées</strong>. Les chiffres de TRI et de VAN sont construits à partir d'un modèle de dispatch, de sorte que les leviers de revenus peuvent être inspectés, contestés et soumis à des tests de sensibilité par les prêteurs et les conseillers techniques.",
    "faq.q5":
      "ValuationPro peut-il prendre en charge des portefeuilles et des projets PV+BESS ?",
    "faq.a5":
      "Oui. ValuationPro permet une analyse reproductible des scénarios à l'échelle d'un portefeuille et modélise explicitement les énergies renouvelables co-implantées, la production réseau, l'écrêtement, les structures de soutien et la co-optimisation avec la batterie. Vous pouvez comparer les opportunités de manière cohérente, identifier où le stockage crée le plus de valeur et sélectionner la meilleure configuration pour chaque projet PV+BESS.",
    "home.quick_actions.forecastpro_coming_soon_text":
      "Notre moteur LT arrive bientôt !",
    "home.resources.docs": "Lire la documentation",
    "home.resources.docs_desc": "Explorez la documentation officielle.",
    "home.quick_actions.dispatchpro_access":
      "Vous pouvez utiliser DispatchPro, notre moteur CT.",
    "sidebar.marketData": "Prix & Indices",
    "webinar.badge": "WEBINAIRE LIVE · 16 JUIN",
    "webinar.title":
      "PV + BESS Co-implantation :<br>dimensionnement, empilement des revenus &amp; TRI",
    "webinar.partners": "Forsyt Energy × Natural Power",
    "webinar.cta": "S'inscrire ici, c'est gratuit",
    "home.scroll_sizing": "Étude de dimensionnement",
    "home.scroll_contact": "Contact",
    "home.clients_title": "Ils nous font confiance",
    "replay.date": "Publié le <time datetime=\"2026-06-18\">18 juin 2026</time>",
    "replay.followup":
      "Pour aller plus loin : notre intervention sur le dimensionnement PV + BESS à France Renouvelables →",
    "replay.eyebrow": "Replay du webinaire",
    "replay.title":
      "Colocalisation PV + BESS :<br>des hypothèses aux résultats",
    "replay.intro":
      "Replay de la session Forsyt Energy et Natural Power sur le dimensionnement du stockage pour un actif PV existant en France.",
    "replay.download": "Télécharger la présentation",
    "about.eyebrow": "Présentation de l'entreprise",
    "home.about_title": "À propos",
    "home.about_p1":
      "<a href=\"forsyt-energy.html\">Forsyt Energy</a> construit des <strong>modèles de revenus spécifiques à chaque actif</strong> pour les batteries de grande capacité sur les marchés européens de l'électricité. Notre moteur ASTRA modélise le comportement de marché des BESS à la granularité du trading : c'est le même moteur qui fait tourner ValuationPro et BenchmarkPro.",
    "home.about_p2":
      "ValuationPro transforme ce moteur en <strong>projections de cash-flows de qualité investissement</strong>. BenchmarkPro l'utilise pour comparer la performance réelle de l'optimiseur à ce que l'actif aurait pu gagner.",
    "nav.platform_title": "Plateforme",
    "nav.platform_desc":
      "Données de marché connectées, valorisation et benchmarking",
    "footer.security": "Sécurité",
    "footer.privacy": "Confidentialité",
    "footer.terms": "Conditions d'utilisation",
    "footer.legal": "Mentions légales",
    "footer.cookies": "Paramètres des cookies",
    "platform.free.eyebrow": "Au cœur de la plateforme",
    "platform.free.title": "Essayez Forsyt par vous-même.",
    "platform.free.desc":
      "Créez un compte gratuit et découvrez en action la plateforme qu'utilisent nos clients. Rejouez une sélection de journées de dispatch BenchmarkPro sur une batterie française de référence, voyez ce que chaque marché apporte au revenu et suivez les niveaux de revenus mensuels des batteries avec le BESS Reference.",
    "platform.free.cta": "Explorer la plateforme",
    "platform.free.shot1": "Niveaux de revenus mensuels",
    "platform.free.shot2": "Revenus de dispatch journaliers",
    "platform.free.shot3": "Cashflows sur la durée de vie",
    "platform.free.shot4_title": "Données de marché",
    "platform.free.shot4": "Indices de spread day-ahead",
  },
  de: {
    "nav.products": "Produkte ▾",
    "nav.solutions": "Lösungen ▾",
    "nav.resources": "Ressourcen ▾",
    "nav.about": "Über uns ▾",
    "nav.about_forsyt_title": "Über Forsyt Energy",
    "nav.about_forsyt_desc": "Unsere Mission, Team & Vision",
    "nav.work_with_us_title": "Karriere",
    "nav.work_with_us_desc": "Werden Sie Teil unseres Teams",
    "nav.contact_title": "Kontakt",
    "nav.contact_desc": "Treten Sie mit uns in Kontakt",
    "nav.demo": "Anruf buchen",
    "nav.insights": "Einblicke",
    "hero.main_title":
      "Erkennen Sie, welche Batterieprojekte gebaut werden sollten.",
    "hero.main_subtitle":
      "ValuationPro testet jede Anlage gegen prognostizierte Preise, Netzrestriktionen, Marktzugang, PV-Co-Location-Konfigurationen und Betriebsstrategien. Unsere Plattform zeigt, was das Projekt verdienen wird, wo die Downside liegt und welche Entscheidungen den Investment Case tragen oder brechen.",
    "hero.what_we_do": "WAS WIR TUN",
    "audience.title": "Wer nutzt ValuationPro?",
    "audience.intro": "Forsyt arbeitet mit:",
    "audience.l1":
      "<strong>BESS-Entwickler und Projektteams</strong>, die den kommerziellen Geschäftsfall für eine neue Anlage aufbauen und Umsatzprognosen benötigen, die im realen Handelsverhalten der Batterie verankert sind.",
    "audience.l2":
      "<strong>Investoren und Kreditgeber</strong>, die Due Diligence bei BESS- oder Hybridprojekten durchführen und IRR- und NPV-Ausgaben mit dokumentierten, anlagenspezifischen Annahmen benötigen, die sie hinterfragen können.",
    "audience.l3":
      "<strong>Solaranlagenbesitzer, die eine Hybridisierung prüfen</strong>, die die Batterie dimensionieren, den Mehrwert quantifizieren und die Konfiguration mit der stärksten Rendite identifizieren müssen, während die Capture-Raten sinken.",
    "audience.market_focus":
      "Wir decken Utility-Scale-Batterien auf europäischen Strommärkten ab, über Day-Ahead, Intraday und Systemdienstleistungen.",
    "about.p3":
      "Wir decken <strong>Standalone-BESS</strong>, hybride <strong>PV- und Wind-Co-Location</strong> sowie <strong>C&I-Anwendungen</strong> ab, einschließlich der Verbrauchsoptimierung für Rechenzentren.",
    "audience.footnote":
      "Anlagenspezifische Umsatzmodellierung, aufgebaut auf einem Trading-Dispatch-Modell.",
    "audience.cta": "ValuationPro live erleben",
    "benchmark.title": "ValuationPro",
    "benchmark.sub":
      "Anlagenspezifische BESS-Bewertung, aufgebaut auf einem Trader-Modell.",
    "bench.key_metrics": "Wichtige BESS-Metriken",
    "bench.card1.title": "Anlage präzise konfigurieren",
    "bench.card1.desc":
      "ValuationPro bildet die realen Parameter Ihrer Batterie ab: Leistung, Degradation, SoC-Limits, Netzrestriktionen und co-located Erneuerbare.",
    "bench.card1.l1":
      "Leistung, Kapazität, Effizienz und SoC-Limits passend zu Hardware und Betrieb.",
    "bench.card1.l2":
      "Degradationskurven, OPEX und Netztarife in den Cashflows abgebildet.",
    "bench.card1.l3":
      "Hybrid-Support für RES-Prognosen, Abregelung, Förderung und Co-Optimierung.",
    "bench.card2.title": "Investitionskennzahlen",
    "bench.card2.desc":
      "Machen Sie aus Dispatch-Simulationen entscheidungsreife Erlösprognosen, IRR, NPV und Amortisation.",
    "bench.card2.l1":
      "Pro-forma-Cashflows über die Lebensdauer mit Investitionskennzahlen.",
    "bench.card2.l3":
      "Revenue Stack nach Produkt: Day-Ahead, Intraday, aFRR und FCR.",
    "bench.card2.l4":
      "Größe, Konfiguration und Annahmen für die Investitionsprüfung vergleichen.",
    "bench.card3.title": "Umsatztreiber & Risiken",
    "bench.card3.desc":
      "Sehen Sie, woher Erlöse kommen, was sie begrenzt und welche Annahmen das Ergebnis treiben.",
    "bench.card3.l1":
      "Monatliche, wöchentliche und tägliche Erlöszusammensetzung nach Marktprodukt.",
    "bench.card3.l2":
      "Throughput, Zyklen und Degradation mit langfristigem Wert verknüpft.",
    "bench.card3.l3":
      "Constraint- und Betriebsdiagnostik für wichtige Sensitivitäten.",
    "bench.card3.l4":
      "Zeitreihen-Export für Sensitivitätsanalysen, Audits und Kreditgeberprüfungen.",
    "about.hero_subtitle":
      "Wir helfen Marktteilnehmern zu verstehen, was eine Batterie realistischerweise hätte erlösen können, wie die tatsächliche Performance im Vergleich abschneidet und woher die Differenz kommt.",
    "about.title": "Unternehmensübersicht",
    "about.p1":
      "<strong>Forsyt Energy</strong> ist ein unabhängiges Analyseunternehmen mit Fokus auf die Performance von Batteriespeichersystemen (BESS). Wir helfen Marktteilnehmern zu verstehen, was eine Batterie realistischerweise hätte erlösen können, wie die tatsächliche Performance im Vergleich abschneidet und woher die Differenz kommt. Wir liefern präzise und verlässliche Analysen als Entscheidungsgrundlage.",
    "about.what_title": "Was Forsyt Energy tut",
    "about.what_p1":
      "Forsyt Energy erstellt anlagenspezifische kommerzielle Referenzen für die Performance von Batteriespeichern. Unsere Arbeit verbindet Markt-Replay, Strommarktexpertise und physikalisch fundierte Modellierung, sodass die Erlösanalyse die tatsächlichen Restriktionen und den Marktzugang der untersuchten Anlage abbildet.",
    "about.what_p2": "Unser Produktangebot umfasst:",
    "about.bench_title": "BenchmarkPro",
    "about.bench_desc":
      "ein anlagenspezifischer Markterlös-Benchmark für BESS, der die finanzielle Performance und die Ausführungsqualität des Optimierers analysiert.",
    "about.val_title": "ValuationPro",
    "about.val_desc":
      "eine Engine zur Erlösschätzung (Bewertung) von BESS über die gesamte Lebensdauer der Anlage, mit hoher Genauigkeit, umfassender Konfigurierbarkeit und nativer Hybridisierung mit erneuerbaren Energien.",
    "about.fore_title": "ForecastPro",
    "about.fore_desc":
      "unser Produkt für Strompreisprognosen, aufgebaut auf unserer eigenen Fundamentalmodell-Engine.",
    "about.what_p3":
      "Wir unterstützen Energieunternehmen und Investoren mit fundierter Expertise in Strommärkten, Regulierung und Anlagenökonomie. Unsere Arbeit wird für Performance-Reviews, Due Diligence, Monitoring, Stakeholder-Reporting und kommerzielle Gespräche eingesetzt, wenn ein generischer Marktindex nicht spezifisch genug ist, um zu beantworten, was für eine bestimmte Batterie realistisch erreichbar war.",
    "about.who_title": "Wen Forsyt Energy bedient",
    "about.who_l1": "Eigentümer von Batterieanlagen, IPPs und Versorger.",
    "about.who_l2":
      "Optimierer und Aggregatoren, die eine glaubwürdige Performance-Baseline benötigen.",
    "about.who_l3":
      "Banken, Kreditgeber und Investoren, die die Erlösqualität von Batterien bewerten.",
    "about.who_l4":
      "Teams, die für die Überwachung, das Reporting und prüfungsfeste Reviews von BESS verantwortlich sind.",
    "about.where_title": "Wo Forsyt Energy tätig ist",
    "about.where_p1":
      "Forsyt Energy wurde von Julio Quintela Casal und Lucas Durupt gegründet und hat seinen Sitz in Paris. Wir befassen uns mit Fragen zu Batteriespeichern im Utility-Maßstab auf den europäischen Strommärkten. Unsere aktuellen Veröffentlichungen konzentrieren sich auf den Batterie-Dispatch in Europa, einschließlich der Erlöschancen in Day-Ahead, Intraday, FCR und aFRR.",
    "about.services_title": "Unser Dienstleistungsangebot",
    "about.services_p1":
      "Forsyt Energy bietet unabhängige, datengestützte Analysen über den gesamten Lebenszyklus von Batteriespeichern hinweg. Durch die Verknüpfung physikalisch präziser Dispatch-Simulationen mit fundamentaler Strommarktmodellierung unterstützen wir Entwickler, Investoren und Betreiber mit drei Kerndienstleistungen:",
    "about.services_l1":
      "<strong>Performance-Audits & Baselines (unterstützt durch BenchmarkPro):</strong> Wir erstellen einen digitalen Zwilling Ihres BESS, um historische Marktbedingungen nachzustellen. Dies liefert eine neutrale, prüfsichere Baseline zur Bewertung der Dispatch-Qualität, zur Überprüfung der Aggregator-Einnahmen und zur Beilegung kommerzieller Streitigkeiten.",
    "about.services_l2":
      "<strong>Projektbewertung & techno-ökonomische Dimensionierung (unterstützt durch ValuationPro):</strong> Wir simulieren Batterieeinnahmen über die Lebensdauer unter Berücksichtigung von Degradationskurven und Netzanschlussbeschränkungen. Dies unterstützt Due-Diligence-Prüfungen, Erlös-Stack-Optimierung und Dimensionierungsentscheidungen für hybride Co-Location-Projekte (PV + Wind + BESS).",
    "about.services_l3":
      "<strong>Fundamentale Preisszenarien (unterstützt durch ForecastPro):</strong> Wir liefern langfristige, granulare Strompreis- und Volatilitätsprognosen basierend auf unserem eigenen fundamentalen Strommarktmodell. Diese bankfähigen Szenarien unterstützen die Projektfinanzierung, die Einnahmenstrukturierung und Absicherungsstrategien.",
    "about.work_title": "Wie man mit uns arbeitet",
    "about.work_p1":
      "Wenn Sie eine bestimmte Anlage prüfen, ein Pilotprojekt besprechen oder herausfinden möchten, ob BenchmarkPro zu Ihrem Anwendungsfall passt, beginnen Sie auf der <a href=\"index.html\">Startseite</a>, lesen Sie unsere <a href=\"insights.html\">Insights</a> oder schreiben Sie uns an <a href=\"mailto:contact@forsytenergy.com\">contact@forsytenergy.com</a>.",
    "contact.title": "Erzählen Sie uns von Ihrem Projekt",
    "contact.sub":
      "Geben Sie unten Ihre E-Mail-Adresse ein und wir melden uns bei Ihnen.",
    "contact.placeholder": "ihre.email@firma.com",
    "contact.newsletter":
      "Abonnieren Sie unseren zweiwöchentlichen Newsletter für Markteinblicke.",
    "contact.consent":
      'Ich stimme den <a href="terms.html" target="_blank" rel="noopener noreferrer">Nutzungsbedingungen</a> und der <a href="privacy.html" target="_blank" rel="noopener noreferrer">Datenschutzrichtlinie</a> zu.',
    "contact.button": "Kontakt aufnehmen",
    "contact.direct": "Oder schreiben Sie uns direkt an ",
    "cookie.text":
      'Wir verwenden essentielle Cookies für die grundlegende Funktionalität der Website. Mit Ihrer Zustimmung verwenden wir auch Cookies für anonyme Analysen, um zu verstehen, wie Sie die Website nutzen, was eine Sitzungsaufzeichnung beinhalten kann. Dies hilft uns, unsere Website zu verbessern. Erfahren Sie mehr in unserer <a href="/privacy.html">Datenschutzerklärung</a>.',
    "cookie.reject": "Alle ablehnen",
    "cookie.accept": "Alle annehmen",
    "pilot.title": "ValuationPro Dimensionierungsstudie",
    "pilot.sub":
      "Ein <strong>vollständiger BESS-Investitionsfall</strong> für Ihre Anlage, in zwei Wochen.",
    "pilot.price":
      '<s class="price-old">7.000 €</s><span class="price-current">3.000 € zzgl. MwSt.</span>',
    "pilot.get.title": "Was Sie bekommen",
    "pilot.get.l1":
      "ValuationPro für Ihre Anlage über <strong>bis zu vier BESS-Szenarien</strong> konfiguriert.",
    "pilot.get.l2":
      "Plattformzugang während der gesamten Beauftragung, mit vollständiger Visualisierung der Ergebnisse.",
    "pilot.get.l3":
      "Ein kurzer Bericht und ein <strong>modellfähiger Datenexport</strong> mit allen Szenarienergebnissen, einschließlich der jährlichen Umsatzaufschlüsselung nach Marktprodukt.",
    "pilot.inline": "Dimensionierungsstudie starten",
    "pilot.timeline.title": "Zeitplan",
    "pilot.timeline.t1":
      "<strong>Heute:</strong> 30-minütiger Kick-off-Call. NDA und Beauftragungsschreiben zur Unterzeichnung bereit. Die Studie beginnt innerhalb von 48 Stunden.",
    "pilot.timeline.t2":
      "<strong>Woche 1:</strong> Erste Szenarienergebnisse in ValuationPro verfügbar. Abstimmungspunkt mit Forsyt.",
    "pilot.timeline.t3":
      "<strong>Woche 2:</strong> Lieferung von Bericht und modellfähigem Datenexport mit allen Szenarienergebnissen und Umsatzaufschlüsselung.",
    "pilot.timeline.t4": "",
    "pilot.timeline.t5": "",
    "pilot.cta.book": "Call mit unserem Team buchen",
    "audit.title": "Performance-Benchmark-Audit",
    "audit.sub":
      "Wenn die Fragen wichtig sind, reicht ein Dashboard nicht aus. Erhalten Sie einen strukturierten Überblick darüber, was die Anlage hätte verdienen können, wie die tatsächliche Leistung im Vergleich dazu aussieht und welche Themen Aufmerksamkeit verdienen.",
    "audit.price": "4.900 € zzgl. MwSt.",
    "audit.get.title": "Was Sie erhalten",
    "audit.get.l1":
      "Eine strukturierte Überprüfung der jüngsten Anlagenleistung durch anlagenspezifisches Trading-Replay.",
    "audit.get.l2":
      "Klare Umsatzaufschlüsselung nach Produkt, einschließlich Spot, Intraday und Systemdienstleistungen.",
    "audit.get.l3":
      "Tiefgreifende Analysen der Entscheidungen und Bedingungen, die die Ergebnisse am meisten beeinflusst haben.",
    "audit.get.l4":
      "Praktische Empfehlungen für Überwachung, Berichterstattung und die nächsten Prioritäten.",
    "audit.cta.book": "Audit besprechen",
    "audit.note": "",
    "audit.sample": "Deliverables (Vollbild - zum Öffnen klicken)",
    "faq.title": "Häufig gestellte Fragen (FAQ)",
    "faq.q1": "Wie erstellt ValuationPro Umsatzprognosen?",
    "faq.a1":
      "ValuationPro läuft auf <strong>ASTRA</strong>, Forsyts proprietärem BESS-Dispatch-Modell. Es optimiert Ihre Anlage über alle relevanten Märkte (Day-Ahead, Intraday, aFRR, FCR) in 15-Minuten-Granularität, konfiguriert auf Ihre spezifischen technischen Parameter. Cashflow-Prognosen werden aus dem Dispatch-Output aufgebaut.",
    "faq.q2":
      "Welche Informationen benötige ich für eine Dimensionierungsstudie?",
    "faq.a2":
      "Grundlegende Anlagenparameter: Nennleistung, Kapazität, Standort und für Hybridprojekte die ENR-Konfiguration. Bei unvollständigen Daten greifen wir auf die BESS-Wissensdatenbank von Forsyt zurück und kennzeichnen, welche Annahmen am empfindlichsten auf das Ergebnis reagieren.",
    "faq.q4":
      "Kann die Ausgabe in formellen Finanzierungen oder Due-Diligence-Prüfungen verwendet werden?",
    "faq.a4":
      "Ja. Die Methodik ist anlagenspezifisch und die Annahmen sind <strong>vollständig dokumentiert</strong>. Die IRR- und NPV-Zahlen sind aus einem Dispatch-Modell aufgebaut, sodass die Umsatztreiber von Kreditgebern und technischen Beratern inspiziert, hinterfragt und Stresstests unterzogen werden können.",
    "faq.q5": "Unterstützt ValuationPro Portfolios und PV+BESS-Projekte?",
    "faq.a5":
      "Ja. ValuationPro unterstützt wiederholbare Szenarioanalysen über Projektportfolios hinweg und modelliert co-lokalisierte erneuerbare Erzeugung, Netzeinspeisung, Abregelung, Förderstrukturen und die Co-Optimierung mit der Batterie. So lassen sich Chancen konsistent vergleichen, der größte Speichernutzen bestimmen und die stärkste Konfiguration für jedes PV+BESS-Projekt identifizieren.",
    "home.quick_actions.forecastpro_coming_soon_text":
      "Unser LT-Modul kommt bald!",
    "home.resources.docs": "Dokumentation lesen",
    "home.resources.docs_desc": "Entdecken Sie die offizielle Dokumentation.",
    "home.quick_actions.dispatchpro_access":
      "Sie können DispatchPro, unser CT-Modul, nutzen.",
    "sidebar.marketData": "Preise & Indizes",
    "webinar.badge": "LIVE-WEBINAR · 16. JUNI",
    "webinar.title":
      "PV + BESS Co-Standort:<br>Dimensionierung, Erlösstapelung &amp; IRR",
    "webinar.partners": "Forsyt Energy × Natural Power",
    "webinar.cta": "Hier kostenlos anmelden",
    "home.scroll_sizing": "Dimensionierungsstudie",
    "home.scroll_contact": "Kontakt",
    "home.clients_title": "Sie vertrauen uns",
    "replay.date": "Veröffentlicht am <time datetime=\"2026-06-18\">18. Juni 2026</time>",
    "replay.followup":
      "Weiterführend: unser Vortrag zur Dimensionierung von PV + BESS bei France Renouvelables →",
    "replay.eyebrow": "Webinar-Aufzeichnung",
    "replay.title": "PV + BESS Co-Location:<br>Von Annahmen zu Ergebnissen",
    "replay.intro":
      "Aufzeichnung der gemeinsamen Session von Forsyt Energy und Natural Power zur Speicherdimensionierung für eine bestehende PV-Anlage in Frankreich.",
    "replay.download": "Präsentation herunterladen",
    "about.eyebrow": "Unternehmensübersicht",
    "home.about_title": "Über uns",
    "home.about_p1":
      "<a href=\"forsyt-energy.html\">Forsyt Energy</a> entwickelt <strong>anlagenspezifische Erlösmodelle</strong> für Batteriespeicher im Utility-Maßstab auf den europäischen Strommärkten. Unsere ASTRA-Engine modelliert das Marktverhalten von BESS in Trading-Granularität – dieselbe Engine, die hinter ValuationPro und BenchmarkPro steht.",
    "home.about_p2":
      "ValuationPro macht aus dieser Engine <strong>investmentfähige Cashflow-Prognosen</strong>. BenchmarkPro nutzt sie, um die tatsächliche Performance des Optimierers mit dem zu vergleichen, was die Anlage hätte erlösen können.",
    "nav.val_title": "ValuationPro",
    "nav.val_desc": "Lebenszyklus-Cashflow- & Bewertungsplattform für BESS",
    "nav.bench_title": "BenchmarkPro",
    "nav.bench_desc": "Anlagenspezifische Performance-Audits & Baselines",
    "nav.toll_title": "Tolling & Optimierung",
    "nav.toll_desc": "Vertragsstrukturen & Dispatch-Optimierung",
    "nav.coloc_title": "PV + BESS Co-Location",
    "nav.coloc_desc": "Dimensionierung & Co-Optimierung hybrider Anlagen",
    "nav.audit_title": "Performance-Audits",
    "nav.audit_desc":
      "Unabhängige, prüfungsfeste Verifizierung der Capture-Rate",
    "nav.insights_title": "Insights",
    "nav.insights_desc": "Expertenanalysen & Research zu Strommärkten",
    "nav.bess_ref_title": "BESS Reference",
    "nav.bess_ref_desc":
      "Quartalsweise Erlös-Benchmarks für europäische Batteriespeicher",
    "nav.ai_api_title": "KI- & API-Integration",
    "nav.ai_api_desc":
      "Forsyt-Daten mit eigenen Tools & KI-Assistenten verbinden",
    "nav.platform_title": "Plattform",
    "nav.platform_desc": "Vernetzte Marktdaten, Bewertung und Benchmarking",
    "footer.security": "Sicherheit",
    "footer.privacy": "Datenschutz",
    "footer.terms": "Nutzungsbedingungen",
    "footer.legal": "Impressum",
    "footer.cookies": "Cookie-Einstellungen",
    "platform.free.eyebrow": "Einblick in die Plattform",
    "platform.free.title": "Testen Sie Forsyt selbst.",
    "platform.free.desc":
      "Erstellen Sie ein kostenloses Konto und erleben Sie die Plattform unserer Kunden in Aktion. Spielen Sie ausgewählte BenchmarkPro-Dispatch-Tage einer französischen Referenzbatterie nach, sehen Sie, was jeder Markt zum Erlös beiträgt, und verfolgen Sie mit der BESS Reference die monatlichen Erlösniveaus von Batterien.",
    "platform.free.cta": "Plattform entdecken",
    "platform.free.shot1": "Monatliche Erlösniveaus",
    "platform.free.shot2": "Tägliche Dispatch-Erlöse",
    "platform.free.shot3": "Cashflows über die Lebensdauer",
    "platform.free.shot4_title": "Marktdaten",
    "platform.free.shot4": "Day-Ahead-Spread-Indizes",
  },
};

const toggle = document.getElementById("langToggle");
const languages = ["en", "fr", "de"];
const LANG_STORAGE_KEY = "forsyt-lang";

// Pages with static /fr/ and /de/ copies (built by scripts/build-i18n.js)
// carry data-static-lang and hreflang links: they are served in their own
// language and the toggle moves between URLs. Other pages still swap text.
const staticLang = document.documentElement.dataset.staticLang;
const alternates = {};
document.querySelectorAll('link[rel="alternate"][hreflang]').forEach((l) => {
  if (languages.includes(l.hreflang)) alternates[l.hreflang] = new URL(l.href).pathname;
});
const goTo = (target) => {
  if (alternates[target] && alternates[target] !== window.location.pathname) {
    window.location.assign(alternates[target] + window.location.search + window.location.hash);
    return true;
  }
  return false;
};

let stored = null;
try {
  stored = localStorage.getItem(LANG_STORAGE_KEY);
} catch (e) {}
let lang = staticLang || (languages.includes(stored) ? stored : "en");
// A language the visitor picked earlier with the toggle wins over the page's.
if (staticLang && languages.includes(stored) && stored !== staticLang) goTo(stored);

// Original (English) content per element, so a key missing in FR/DE falls
// back to English instead of keeping the previously shown language.
const originals = new WeakMap();

function applyLang() {
  const pageI18n = window.FORSYT_PAGE_I18N || {};
  const dict =
    lang === "en" ? {} : { ...(i18n[lang] || {}), ...(pageI18n[lang] || {}) };
  document.querySelectorAll("[data-i]").forEach((el) => {
    const isField = el.tagName === "INPUT" || el.tagName === "TEXTAREA";
    if (!originals.has(el)) {
      originals.set(el, isField ? el.placeholder : el.innerHTML);
    }
    const k = el.getAttribute("data-i");
    const text = k in dict ? dict[k] : originals.get(el);
    if (isField) {
      el.placeholder = text;
    } else if (el.innerHTML !== text) {
      el.innerHTML = text;
    }
  });
  if (toggle) toggle.textContent = lang.toUpperCase();
  document.documentElement.lang = lang;
  window.forsytLang = lang;
  document.dispatchEvent(
    new CustomEvent("forsyt:langchange", { detail: { lang } }),
  );
}
window.forsytApplyLang = applyLang;

if (toggle) {
  toggle.addEventListener("click", () => {
    const currentIndex = languages.indexOf(lang);
    const next = languages[(currentIndex + 1) % languages.length];
    try {
      localStorage.setItem(LANG_STORAGE_KEY, next);
    } catch (e) {}
    if (staticLang && goTo(next)) return;
    lang = next;
    applyLang();
  });
}

applyLang();

const navToggle = document.getElementById("navToggle");
const mainNav = document.getElementById("mainNav");

if (navToggle && mainNav) {
  const closeNav = () => {
    navToggle.setAttribute("aria-expanded", "false");
    document.body.classList.remove("nav-open");
    mainNav
      .querySelectorAll(".dropdown.is-open")
      .forEach((dropdown) => dropdown.classList.remove("is-open"));
  };

  navToggle.addEventListener("click", () => {
    const isOpen = document.body.classList.toggle("nav-open");
    navToggle.setAttribute("aria-expanded", String(isOpen));
  });

  mainNav.querySelectorAll(".dropdown-trigger").forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      event.preventDefault();
      const dropdown = trigger.closest(".dropdown");
      const wasOpen = dropdown.classList.contains("is-open");
      mainNav
        .querySelectorAll(".dropdown.is-open")
        .forEach((d) => d.classList.remove("is-open"));
      if (!wasOpen) dropdown.classList.add("is-open");
    });
  });

  mainNav.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", closeNav);
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") closeNav();
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 768 && document.body.classList.contains("nav-open")) {
      closeNav();
    }
  });
}
